<template>
    <div>
        <p class="text-muted mb-4 mt-3 text-center">
            {{ headerText }}
        </p>

        <phone-form v-if="!phone" @otp-sent="onOTPSent" />
        <otp-form v-else :phone="phone" />
    </div>
</template>

<script>
import OTPForm from '@/components/auth/OTPForm';
import PhoneForm from '@/components/auth/PhoneForm';

export default {
    components: {
        PhoneForm,
        'otp-form': OTPForm
    },

    page: {
        title: 'Login'
    },

    data() {
        return {
            phone: ''
        };
    },

    computed: {
        headerText() {
            if (this.phone) {
                return 'OTP has been sent to provided phone number.';
            }

            return 'Enter your phone number to access admin panel.';
        }
    },

    methods: {
        onOTPSent(phone) {
            this.phone = phone;
        }
    }
};
</script>
